export default __webpack_public_path__ + "static/media/16.877d8d82.jpg";